import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"
import TenantEmployee, { ITenantEmployee } from "./TenantEmployee"

export interface IGetTenantEmployeesDto {
    entities?: ITenantEmployee[] | null
    links: IApiLink[]
}

export interface IUpdateTenantEmployeesDto {
    entities: ITenantEmployee[]
}

export default class TenantEmployees {
    entities: TenantEmployee[]
    linkUpdate?: IApiLink

    constructor(dto: IGetTenantEmployeesDto) {
        this.entities = dto.entities?.map(e => new TenantEmployee(e)) || []
        this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsEmployees && lnk.rel === ApiLinkRel.upsert)
    }
}
